'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import $ from 'jquery';

var ComponentData = /*#__PURE__*/function () {
  function ComponentData(properties) {
    _classCallCheck(this, ComponentData);

    $.extend(this, properties);
  } // Extend to init more data


  _createClass(ComponentData, [{
    key: "init",
    value: function init(grade) {
      this.setGrade(grade);
      this.setGradeType(grade);
      this.setDisplayValue(grade);
      return this;
    }
  }, {
    key: "setGrade",
    value: function setGrade(grade) {
      this.resultGrade = grade;
    } // Override to set specific type

  }, {
    key: "setGradeType",
    value: function setGradeType() {} // Override to set specific display values

  }, {
    key: "setDisplayValue",
    value: function setDisplayValue() {}
  }]);

  return ComponentData;
}();

export default ComponentData;